export default {
  inserted(el, { modifiers }) {
    const permissionList = JSON.parse(sessionStorage.getItem('permissions'))
    if (Object.keys(modifiers).every(key => !permissionList.includes(key)))
      el.style.display = 'none'
  },
}
